<template>
  <div>
    <div v-if="!googleLoaded">
      <div class="w-full py-5 bg-gray-100 border rounded animate-pulse"></div>
    </div>
    <VueGoogleAutocomplete v-else
      ref="address"
      :id="id"
      :name="name"
      :types="types"
      :classname="inputClass"
      :placeholder="placeholder"
      :country="countryOverride"
      @placechanged="onPlaceChanged"
      @inputChanged="onInputChanged" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'AddressAutocomplete',

  components: {
    VueGoogleAutocomplete
  },

  props: {
    name: {
      type: String,
      default: 'address'
    },

    countries: {
      type: Array
    },

    id: {
      type: String,
      required: true
    },

    inputClass: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: 'Start typing an address'
    },

    types: {
      type: String,
      default: ''
    },

    initialValue: {
      type: String
    }
  },

  created () {
    if (this.countries) {
      this.countryOverride = this.countries
    } else {
      this.countryOverride = [this.account.country]
    }
  },

  async mounted () {
    await this.loadGoogleMapsAutocomplete()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      googleLoaded: false
    }
  },

  methods: {
    async loadGoogleMapsAutocomplete () {
      await this.$loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyAEY38I0fUX5KRb3oc8x-BDu_I_8_jDy6s&libraries=places')
      this.googleLoaded = true
      
      setTimeout(() => {
        // Stops browser autocomplete appearing over address autocomplete
        this.$refs.address.$el.setAttribute('autocomplete', 'disabled')
        this.$refs.address.$el.setAttribute('name', 'disable-autofill-hack-search')

        if (this.initialValue) {
          this.$refs.address.$el.value = this.initialValue
        }

        this.$emit('loaded')
      }, 1000)
    },

    onPlaceChanged (addressData, placeResultData, id) {
      this.$emit('placechanged', { addressData, placeResultData, id })
    },

    onInputChanged (event) {
      this.$emit('inputChanged', event)
    },
  }
}
</script>